//
// EntryService
//  access point to contentful data cms
//
function entryServiceFactory($http, $q, config, reportdata) {
    'ngInject';

    var contentful = config.contentful;
    var locale = reportdata.locale;

    return {
        getEntry: function(assetID) {
            return $http.get(contentful.url + contentful.spaceid + '/entries/' + assetID + '/?access_token=' + contentful.access_token + '&locale=' + locale,
                    { cache: true }
                ).then(function(response) {
                    if (typeof response.data === 'object') {
                        return response.data;
                    } else {
                        console.log("TextService invalid response: assetID: " + assetID);
                        return $q.reject(response.data);
                    }
                }, function(response) {
                    console.log("EntryService error: assetID: " + assetID);
                    return $q.reject(response.data);
                });
        }
      }
}

export default angular.module('mars.vet.services.entry', ["ng"]).factory("EntryService", entryServiceFactory).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/entry.service.js